export const MenuActions = {
  DELETE: 'DELETE_MENU',
  UPSERT: 'UPSERT_MENU',
  GET: 'GET_MENU',
  LIST_MENUS: 'LIST_MENUS',
  GET_QUEUES: 'GET_QUEUES',
  GET_FLOWS: 'GET_FLOWS',
  GET_PROMPTS: 'GET_PROMPTS',
  SET_CUSTOMER_QUEUE_FLOWS: 'SET_CUSTOMER_QUEUE_FLOWS',
  LOADING_MENUS: 'LOADING_MENUS',
  DELETING_MENU: 'DELETING_MENU',
  LOADING_QUEUE_TREATMENT: 'LOADING_QUEUE_TREATMENT',
  LIST_QUEUE_TREATMENT: 'LIST_QUEUE_TREATMENT',
};

export function menuReducer(state: any, action: any) {
  switch (action.type) {
    case MenuActions.DELETE: {
      // @todo Potentially remove menu from list instead of listing again
      return {
        ...state,
        deletingMenu: false,
      };
    }
    case MenuActions.DELETING_MENU: {
      // @todo Potentially remove menu from list instead of listing again
      return {
        ...state,
        deletingMenu: action.payload,
      };
    }
    case MenuActions.UPSERT: {
      // @todo Potentially append menu in list instead of listing again
      return state;
    }
    case MenuActions.GET: {
      // @todo append latest menu to list so the newest content is there in state
      return {
        ...state,
        workingMenu: action.payload.workingMenu,
      };
    }
    case MenuActions.LOADING_MENUS: {
      return {
        ...state,
        loadingMenus: action.payload,
      };
    }
    case MenuActions.LIST_MENUS: {
      return {
        ...state,
        menusLoaded: true,
        loadingMenus: false,
        menuList: action.payload.menuList,
      };
    }
    case MenuActions.GET_QUEUES:
      return {
        ...state,
        queuesLoaded: true,
        queues: action.payload.queues,
      };
    case MenuActions.GET_FLOWS:
      return {
        ...state,
        flowsLoaded: true,
        flows: action.payload.flows,
      };
    case MenuActions.GET_PROMPTS:
      return {
        ...state,
        promptsLoaded: true,
        prompts: action.payload.prompts,
      };
    case MenuActions.SET_CUSTOMER_QUEUE_FLOWS:
      return {
        ...state,
        customerQueueFlows: action.payload.customerQueueFlows,
      };
    case MenuActions.LOADING_QUEUE_TREATMENT: {
      return {
        ...state,
        loadingQueueTreatments: action.payload,
      };
    }
    case MenuActions.LIST_QUEUE_TREATMENT: {
      return {
        ...state,
        queueTreatmentLoaded: true,
        loadingQueueTreatments: false,
        queueTreatmentList: action.payload.queueTreatmentList,
      };
    }
    default:
      return state;
  }
}
